import type {ComponentProps} from "react";

import {useImages} from "../../contexts/images";
import {useSetting} from "../../contexts/setting";
import BgTransformer from "../../layout/BgTransformer";
import {
  getLivestreamDefaultTransform,
  getLivestreamFallbackBackground,
  type LivestreamTemplateId,
} from "./productBackgrounds";

type Props = Omit<ComponentProps<typeof BgTransformer>, "src"> & {
  id: LivestreamTemplateId;
};

/** Render the current product's Livestream background through BiggerPicture. */
export default function LivestreamBackground({id, ...props}: Props) {
  const {customBgs} = useImages() as {customBgs: Record<string, string | undefined>};
  const {product} = useSetting() as {product: {value: string} | null};
  if (!product) throw new Error("Livestream background rendered without a product");
  const source = customBgs[id] || getLivestreamFallbackBackground(product.value, id);
  const defaultTransform = getLivestreamDefaultTransform(product.value, id);

  return <BgTransformer {...props} id={id} src={source} defaultTransform={defaultTransform} />;
}
